import { Component, OnInit } from '@angular/core';
import { WorkflowActionHistoryComponent } from '@dsvs/workflow-generator-ui-lib';

@Component({
  selector: 'fes-fes-workflow-action-dms-number-history',
  templateUrl: './fes-workflow-action-dms-number-history.component.html',
  styleUrls: ['./fes-workflow-action-dms-number-history.component.scss']
})
export class FesWorkflowActionDmsNumberHistoryComponent extends WorkflowActionHistoryComponent implements OnInit {

}
